import { Box } from "@mui/material";
import React from "react";

interface IAdminConsoleWrapper {
    children: React.ReactNode;
}

export const AdminConsoleWrapper: React.FC<IAdminConsoleWrapper> = ({
    children
}) => {
    return (
        <Box sx={{
            padding: '30px',
            backgroundColor: '#F7F8FA',
            height: '100%',
            width: "100%s"
        }}>
            <Box sx={{
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '1px solid #0000001A',
                borderRadius: '4px',
                padding: '30px',
            }}>
                { children }
            </Box>
        </Box>
    )
}